module.exports = __webpack_public_path__ + "img/logo-bighash-white-rgb.e3f88bce.svg";